export default __webpack_public_path__ + "static/media/ConversionsOrangeIcon.9d26fbf6.png";